export default __webpack_public_path__ + "static/favicon-0d66cb6271ad198865324fff9df9ce19.png";